<template>
  <div class="Mailbox">
    <div class="textBox">
      <p>尊敬的来信人，您好！</p>
      <p>
        为进一步增进智能学院与学生的密切联系，更好地解决学生普遍关心的实际问题，学院专门设立了"书记信箱"(以下简称"信箱")。为了使”信箱更好地发挥作用，请您在使用时注意以下几点:
      </p>
      <p>1、智能学院欢迎各位同学就生活和学习中存在的问题提出意见和建议。</p>
      <p>2、来信内容应遵守中华人民共和国法律、法规，并应客观真实。</p>
      <p>   
        3、建议您尽量详细地描述所反映问题，并填写真实的联系方式，以便及时反馈办理情况。
      </p>
      <p>
        4、对于已经答复过的事项，"信箱"可不予受理，请勿就答复过的问题重复提交信件。感谢您对我们工作的支持与配合!
      </p>
    </div>
    <div id="tips"></div>

    <ul id="yzxxID" class="yzxx">

      <div class="inputBox">
        <label>姓名<span>*</span></label>
        <input
          id="myName"
          type="text"
          placeholder="请输入您的姓名"
          v-model="mailName"
        />
      </div>
      <div class="inputBox">
        <label>邮箱<span>*</span></label>
        <input
          id="myEmail"
          type="text"
          placeholder="请输入您的电子邮箱"
          v-model="mailEmail"
        />
      </div>
      <div class="inputBox">
        <label>电话<span>*</span></label>
        <input
          type="text"
          id="myPhone"
          v-model="mailPhone"
          placeholder="请输入您的电话"
        />
      </div>
      <div class="inputBox max">
        <label>标题<span>*</span></label>
        <input
          id="myTitleId"
          type="text"
          placeholder="请输入标题"
          v-model="mailTitle"
        />
      </div>
      <div class="inputBox max inputBox">
        <label>内容<span>*</span></label>
        <div class="textareaBox ">
          <textarea
            id="textID"
            name=""
            v-model="mailInfo"
            placeholder="请输入内容"
            cols="30"
            rows="10"
          ></textarea>
        </div>
      </div>
    </ul>
    <a class="btn_send" @click.stop="sendMail">点击发送</a>
  </div>
</template>

<script>
export default {
  name: "mailbox",
  props: {
    dataList: {
      // 图片列表
      type: Array,
      default: () => []
    },
    moreLink: {
      type: String,
      default: ""
    },
    styles: {
      type: Object,
      default: () => {
        return {
          width: 1920,
          height: 500
        };
      }
    }
  },
  data() {
    return {
      mailPhone: "",
      mailName: "",
      mailTitle: "",
      mailInfo: "",
      mailEmail: ""
    };
  },
  methods: {
    sendMail() {
      if (
        this.mailName &&
        this.mailEmail &&
        this.mailPhone &&
        this.mailTitle &&
        this.mailInfo &&
        this.$route.query.CId
      ) {
        var senddata = this.Base.sendMail({
          Name: this.mailName,
          Email: this.mailEmail,
          Mobile: this.mailPhone,
          Title: this.mailTitle,
          Info: this.mailInfo,
          ColumnID: this.$route.query.CId
        });
        if (senddata.state == "发送成功") {
          this.$root.showTips(senddata.state, "ok", 60, 3);
          // this.mailName = "";
          this.mailEmail = "";
          this.mailPhone = "";
          this.mailTitle = "";
          this.mailInfo = "";
        } else {
          // console.log("2222222222222");
          this.$root.showTips(senddata.message, "warn", 60, 3);
        }

        console.log("senddata.state>>>>>>>>>>", senddata);
      } else {
        // console.log("1111111111");
        this.$root.showTips("请输入完整内容", "warn", 60, 3);
      }
    }
  }
};
</script>

<style lang="less" scoped>
// #0376BE
.Mailbox {
  width: 6.96rem;
  margin: 0 auto;
  .textBox {
    background: #fff;
    padding: 0.3rem;
    // height: 400rem;
    p {
      &:first-child {
        text-indent: 0rem;
      }
      letter-spacing: 0.01rem;
      font-size: 0.18rem;
      color: rgb(51, 51, 51);
      line-height: 2;
      text-align: justify;
      text-indent: 0.38rem;
    }
  }
  .btn_send {
    display: block;
    font-size: 0.16rem;
    font-family: "Microsoft YaHei";
    line-height: 1.5;
    padding: 0.05rem 0.05rem;
    // border: 1rem solid #0376BE;
    width: 1rem;
    text-align: center;
    letter-spacing: 0.02rem;
    border-radius: 0.3rem;
    margin: 0.2rem auto;
    background: #0376be;
    color: #fff;
  }

  .yzxx {
    padding-top: 0.3rem;
    min-height: 4.8rem;
    font-size: 0;
  }
  .yzxx .inputBox {
    display: inline-block;
    width: 6.5rem;
    height: 0.6rem;
    margin-right: 0.4rem;
  }
  .yzxx .inputBox > label {
    font-size: 0.16rem;
    color: #0376be;
  }
  .yzxx .inputBox > input {
    display: inline-block;
    width: 5.5rem;
    border-radius: 0.05rem;
    margin-left: 0.15rem;
    font-size: 0.14rem;
    border: 0.01rem solid #0376be;
    padding: 0.07rem 0.1rem 0.05rem 0.1rem;
  }
  .yzxx .inputBox > input::placeholder {
    color: #999;
  }

  .yzxx .inputBox .textareaBox {
    display: inline-block;
    margin-left: 0.15rem;
    width: 5.7rem;
    margin-right: 0.05rem;
    border-radius: 0.05rem;
    height: 1.9rem;
    border: 0.01rem solid #0376be;
    overflow: hidden;
  }
  .yzxx .inputBox .textareaBox > textarea {
    width: 5.7rem;
    margin-top: -0.01rem;
    margin-left: -0.01rem;

    font-size: 0.16rem;
    padding: 0.1rem;
  }
  .yzxx .inputBox .textareaBox > textarea::placeholder {
    color: #999;
  }
  .yzxx .inputBox.max > label {
    vertical-align: top;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mailbox.vue